export default "__VITE_ASSET__CgsSqti9__"